import { render, staticRenderFns } from "./ComTaskForm.vue?vue&type=template&id=6704804e&"
import script from "./ComTaskForm.vue?vue&type=script&lang=js&"
export * from "./ComTaskForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports